<template>
  <section>
    <div ref="navigationSlider" class="col-12 nav-col-top">
      <IconNavigation :set="set" />
    </div>
    <div class="container-fluid container-set">
      <div class="row">
        <div class="col-12 col-xl-6 image-col-left">
          <SetImage :set="set" :getApiHost="getApiHost" />
          <SetList :currentItem="set.currentItem" :items="set.items" />
          <SetOverview :set="set" />
        </div>
        <div class="col-12 col-xl-6 image-col-right visual_mode_show">
          <Warehouse
            v-if="
              config.visualMode === 'warehouse' && showItemDetails === false
            "
          ></Warehouse>
          <FormMain
            v-if="config.visualMode === 'conf' && showItemDetails === false"
          ></FormMain>
          <ItemDetails v-if="showItemDetails === true"></ItemDetails>
          <SetOverviewDescription
            v-if="
              config.visualMode === 'show' &&
              !showItemDetails &&
              (set.currentItem === 'overview' || set.currentItem === 'set')
            "
            :set="set"
          />
          <SetItemDescription
            v-if="
              config.visualMode === 'show' &&
              !showItemDetails &&
              set.currentItem !== 'all' &&
              set.currentItem !== 'overview' &&
              set.currentItem !== 'set'
            "
            :currentItem="set.currentItem"
            :items="set.items"
          />
          <SetAddItem
            v-if="set.currentItem === 'all'"
            :currentItem="set.currentItem"
            :additionalItems="set.additionalItems"
            :getApiHost="getApiHost"
          />
        </div>
        <div
          id="LastConfigured"
          class="col-12"
          v-if="showLastConfigured === true"
        >
          <LastConfigured />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";

import SetImage from "./Set/Image";
import SetList from "./Set/List";
import SetOverview from "./Set/Overview";
import SetAddItem from "./Set/AddItem";
import SetItemDescription from "./Set/Item/Description";
import SetOverviewDescription from "./Set/Overview/Description";
import FormMain from "./Forms/Main";
import MediaQuery from "@/assets/Helper/MediaQuery";
import IconNavigation from "@/components/IconNavigation";
import Warehouse from "@/components/Warehouse";
import LastConfigured from "@/components/LastConfigured";
import ItemDetails from "@/components/ItemDetails";
import Status from "@/vuex/Status";

export default {
  name: "Set",
  data() {
    return {
      config: Config.getters.getConfig,
      getApiHost: Config.getters.getApiHost,
      set: SetData.getters.getSet,
      currentNavigation: "",
      showSideMenu: Config.getters.getShowSideMenu,
      showLastConfigured: Config.getters.getShowLastConfigured,
      showItemDetails: false,
      hasItemTypeMix: false,
      isVariationInSet: false,
      isCurrentItemVariation: false,
      qualityMapping: {
        // Diamond Exchange
        1: {
          colorId: 7,
          purityId: 1,
        },
        2: {
          colorId: 7,
          purityId: 3,
        },
        3: {
          colorId: 6,
          purityId: 7,
        },
        4: {
          colorId: 7,
          purityId: 7,
        },
        5: {
          colorId: 9,
          purityId: 7,
        },
        7: {
          colorId: 2,
          purityId: 1,
        },
        8: {
          colorId: 2,
          purityId: 7,
        },
        9: {
          colorId: 6,
          purityId: 1,
        },
        27: {
          colorId: 6,
          purityId: 3,
        },
        31: {
          colorId: 2,
          purityId: 11,
        },
        41: {
          colorId: 10,
          purityId: 7,
        },
      },
    };
  },
  components: {
    SetImage,
    SetList,
    SetOverview,
    SetAddItem,
    SetItemDescription,
    FormMain,
    SetOverviewDescription,
    IconNavigation,
    Warehouse,
    LastConfigured,
    ItemDetails,
  },
  mounted() {
    this.$root.$on("showItemDetails", () => {
      this.showItemDetails = true;
    });
    this.$root.$on("hideItemDetails", () => {
      this.showItemDetails = false;
    });
    if (
      this.isDesktop &&
      Config.getters.isShopLoginActive &&
      Status.getters.isInit
    ) {
      this.setShowLastConfigured(true);
    }
  },
  beforeDestroy() {
    this.$root.$off("showItemDetails");
    this.$root.$off("hideItemDetails");
  },
  watch: {
    set: {
      handler: function () {
        this.isCurrentItemVariation =
          !isNaN(this.set.currentItem) &&
          this.getSetIdOfVariations(this.set.currentItem).length > 0;
      },
      deep: true,
    },
  },
  methods: {
    isDiamondGroupPline: function (plineId) {
      return plineId === 504 || plineId === 505 || plineId === 506;
    },
    isTotalPriceProduct: function (brandId, plineId) {
      return brandId === 38 || plineId === 540;
    },
    setShowSideMenu: function (show) {
      this.showSideMenu = show;
      this.$root.$emit(
        this.showSideMenu ? "setItemDetailsBtn" : "unsetItemDetailsBtn"
      );
      Config.dispatch("setShowSideMenu", show).then(() =>
        this.$root.$emit("updateViewer")
      );
    },
    setShowLastConfigured: function (show) {
      if (MediaQuery.isDesktop()) {
        this.showLastConfigured = show;
        Config.dispatch("setShowLastConfigured", show);
      } else {
        Config.dispatch("setVisualMode", "wishlist").then(() => {
          this.$root.$emit("lastConfigured");
        });
      }
    },
    getSetIdOfVariations: function (currentItemId) {
      let setIds = [];
      let checkSet = {};
      if (typeof this.set.items[currentItemId] === "object") {
        if (
          typeof this.set.items[currentItemId].description === "object" &&
          this.set.items[currentItemId].description.isVariation &&
          this.set.items[currentItemId].description.jewelleryType < 1
        ) {
          setIds.push(this.set.items[currentItemId].description.setId);
        }
      } else {
        for (let itemIdx in this.set.items) {
          if (
            typeof this.set.items[itemIdx].description === "object" &&
            this.set.items[itemIdx].description.isVariation &&
            this.set.items[itemIdx].description.jewelleryType < 1
          ) {
            let tmpSetId = this.set.items[itemIdx].description.setId;

            if (!checkSet[tmpSetId]) {
              setIds.push(tmpSetId);
              checkSet[tmpSetId] = true;
            }
          }
        }
      }
      return setIds;
    },
    getSetIds: function () {
      let setIds = [];

      let i = 0;
      if (SetData.getters.getSetId && SetData.getters.getSetId !== "") {
        setIds[0] = this.$parent
          .correctSetId(SetData.getters.getSetId)
          .toUpperCase();
        i = 1;
      }

      let set = SetData.getters.getSet;
      if (set.items) {
        for (let j in set.items) {
          if (
            set.items[j].description.setId &&
            set.items[j].description.setId !== ""
          ) {
            let tmpSetId = this.$parent
              .correctSetId(set.items[j].description.setId)
              .toUpperCase();
            if (tmpSetId !== "" && tmpSetId !== SetData.getters.getSetId) {
              setIds[i] = tmpSetId;
              ++i;
            }
          }
        }
      }

      return setIds;
    },
    getJewelleryType: function () {
      let jewelleryType = -1;
      let currentItemId = SetData.getters.getCurrentItemId;
      if (!isNaN(currentItemId)) {
        if (
          this.set.items &&
          this.set.items[currentItemId] &&
          typeof this.set.items[currentItemId].description === "object"
        ) {
          jewelleryType = parseInt(
            this.set.items[currentItemId].description.jewelleryType
          );
        }
      }
      return jewelleryType;
    },
    onlyJewellery: function () {
      for (let itemIdx in this.set.items) {
        if (
          parseInt(this.set.items[itemIdx].description["jewelleryType"]) < 1
        ) {
          return false;
        }
      }
      return true;
    },
    onlyWeddingRings: function () {
      for (let itemIdx in this.set.items) {
        if (
          typeof this.set.items[itemIdx].description === "object" &&
          parseInt(this.set.items[itemIdx].description.jewelleryType) !== 0
        ) {
          return false;
        }
      }
      return true;
    },
    onlyBasicModels: function () {
      for (let itemIdx in this.set.items) {
        if (
          typeof this.set.items[itemIdx].description === "object" &&
          !this.set.items[itemIdx].description.isBasicModel
        ) {
          return false;
        }
      }
      return true;
    },
    onlyAlloyCombi: function () {
      for (let itemIdx in this.set.items) {
        if (
          typeof this.set.items[itemIdx].description === "object" &&
          !this.set.items[itemIdx].description.isAlloyCombi
        ) {
          return false;
        }
      }
      return true;
    },
    isCurrentItemDiamond: function (currentItemId) {
      if (!isNaN(currentItemId)) {
        if (
          this.set.items &&
          this.set.items[currentItemId] &&
          typeof this.set.items[currentItemId].description === "object" &&
          parseInt(this.set.items[currentItemId].description.jewelleryType) ===
            5
        ) {
          return true;
        }
      }
      return false;
    },
    isCurrentItemWeddingRing: function (currentItemId) {
      if (isNaN(currentItemId)) {
        currentItemId = SetData.getters.getCurrentItemId;
      }
      if (isNaN(currentItemId)) {
        return this.onlyWeddingRings();
      } else {
        if (
          this.set.items &&
          this.set.items[currentItemId] &&
          typeof this.set.items[currentItemId].description === "object" &&
          parseInt(this.set.items[currentItemId].description.jewelleryType) ===
            0
        ) {
          return true;
        }
        return false;
      }
    },
    isCurrentItemJewellery: function (currentItemId) {
      if (isNaN(currentItemId)) {
        currentItemId = SetData.getters.getCurrentItemId;
      }
      if (isNaN(currentItemId)) {
        return this.onlyJewellery();
      } else {
        if (
          this.set.items &&
          this.set.items[currentItemId] &&
          typeof this.set.items[currentItemId].description === "object" &&
          parseInt(this.set.items[currentItemId].description.jewelleryType) > 0
        ) {
          return true;
        }
        return false;
      }
    },
    isCurrentItemAlloyCombi: function (currentItemId) {
      if (isNaN(currentItemId)) {
        currentItemId = SetData.getters.getCurrentItemId;
      }
      if (isNaN(currentItemId)) {
        return this.onlyAlloyCombi();
      } else {
        if (
          this.set.items &&
          this.set.items[currentItemId] &&
          typeof this.set.items[currentItemId].description === "object" &&
          this.set.items[currentItemId].description.isAlloyCombi
        ) {
          return true;
        }
        return false;
      }
    },
    isCurrentItemBasicModel: function (currentItemId) {
      if (isNaN(currentItemId)) {
        currentItemId = SetData.getters.getCurrentItemId;
      }
      if (isNaN(currentItemId)) {
        return this.onlyBasicModels();
      } else {
        if (
          this.set.items &&
          this.set.items[currentItemId] &&
          typeof this.set.items[currentItemId].description === "object" &&
          this.set.items[currentItemId].description.isBasicModel
        ) {
          return true;
        }
        return false;
      }
    },
    getStonePositionText: function (group) {
      let stonePositionText = "";

      if (group.side) {
        switch (group.side) {
          case "top":
            stonePositionText = this.$t(
              "Menu.list.stones.groups.outside"
            ).toUpperCase();
            break;
          case "left":
            stonePositionText = this.$t(
              "Menu.list.stones.groups.leftShort"
            ).toUpperCase();
            break;
          case "right":
            stonePositionText = this.$t(
              "Menu.list.stones.groups.rightShort"
            ).toUpperCase();
            break;
          case "inside":
            stonePositionText = this.$t(
              "Menu.list.stones.groups.inside"
            ).toUpperCase();
            break;
        }
      }

      return stonePositionText;
    },
    getSizeForDiamondExchange: function () {
      let caratSize = "0";

      let groupData = this.getGroupDataForDiamondExchange();
      if (groupData && groupData.size) {
        if (this.getJewelleryType() === 1) {
          caratSize = (groupData.size / groupData.numberInt).toString();
        } else {
          caratSize = groupData.size.toString();
        }
        caratSize = caratSize.substring(0, caratSize.indexOf(".") + 2);
      }

      if (caratSize == "1" || caratSize == "2") {
        caratSize += ".0";
      }

      return caratSize;
    },
    getStoneformForDiamondExchange: function () {
      let stoneform = "";

      let groupData = this.getGroupDataForDiamondExchange();
      if (groupData && groupData.form) {
        stoneform = groupData.form;
      }

      return stoneform;
    },
    getPurityForDiamondExchange: function () {
      let purity = "";

      let groupData = this.getGroupDataForDiamondExchange();
      if (
        groupData &&
        groupData.qualityId &&
        this.qualityMapping[groupData.qualityId]
      ) {
        purity = this.qualityMapping[groupData.qualityId].purityId + "_id";
      }

      return purity;
    },
    getStoneTypeForDiamondExchange: function () {
      let stoneType = 1;

      let groupData = this.getGroupDataForDiamondExchange();

      if (
        groupData &&
        ((groupData.qualityId &&
          (groupData.qualityId === 92 || groupData.qualityId === 93)) ||
          (groupData.diamondStock && groupData.diamondStock.stoneType === '5'))
      ) {
        stoneType = 5;
      }

      return stoneType;
    },
    getGroupDataForDiamondExchange: function () {
      let stoneGroup = this.getGroupForDiamondExchange();
      let currentItemId = SetData.getters.getCurrentItemId;
      let groupData = {};

      if (
        this.set.items &&
        this.set.items[currentItemId] &&
        this.set.items[currentItemId].description &&
        this.set.items[currentItemId].description.stones &&
        this.set.items[currentItemId].description.stones.groups &&
        this.set.items[currentItemId].description.stones.groups[stoneGroup]
      ) {
        groupData =
          this.set.items[currentItemId].description.stones.groups[stoneGroup];

        if (this.set.items[currentItemId].description.stones.diamondStock) {
          groupData.diamondStock =
            this.set.items[currentItemId].description.stones.diamondStock;
        }
      }
      return groupData;
    },
    getGroupForDiamondExchange: function () {
      let stoneGroup = -1;
      let currentItemId = SetData.getters.getCurrentItemId;

      if (this.set.items && this.set.items[currentItemId]) {
        for (let itemIdx in this.set.items) {
          if (itemIdx == currentItemId) {
            if (
              typeof this.set.items[itemIdx].description === "object" &&
              typeof this.set.items[itemIdx].description.stones == "object" &&
              typeof this.set.items[itemIdx].description.stones.groups ==
                "object"
            ) {
              for (let numericKey in this.set.items[itemIdx].description.stones
                .groups) {
                let groupData =
                  this.set.items[itemIdx].description.stones.groups[numericKey];
                if (
                  (groupData.numberInt == 1 && groupData.size > 0.28) ||
                  (this.getJewelleryType() === 1 && groupData.size >= 0.6)
                ) {
                  stoneGroup = numericKey;
                }
              }
            }
          }
        }
      }
      return stoneGroup;
    },
  },
  computed: {
    isDesktop() {
      return MediaQuery.isDesktop();
    },
  },
};
</script>

<style lang="scss">
.padding-null {
  padding: 0 !important;
}

.content-node {
  padding-bottom: 5rem !important;
}

.container-set {
  background-color: #ffffff;
}

.visual_mode_show {
  padding-bottom: 4rem;
}

@media (min-width: 1200px) {
  .container-set {
    background-color: transparent;
  }

  .image-col-left {
    min-height: 100rem;
  }

  .nav-col-top {
    display: flex;
    justify-content: flex-start;
    border-top: 0.1rem solid $darkGrey;
    background-color: $white;
    height: 6rem;
    margin-bottom: 1.5rem;
    width: auto;
  }

  .visual_mode_show {
    height: max-content;

    .container,
    .container-fluid {
      background-color: #ffffff;
    }
  }

  .image-bg-node {
    position: absolute;
    top: 4.85rem;
    height: 30em;
    width: 100vw;
    z-index: 1;
    background-color: $lightGreyBg;
  }
}
</style>
